// region Imports
import axios from "axios";
import Utilities from "../../../Helpers/Utilities";
import {
    receivedServerError,
    receivedUnauthorizedError,
    receivedExpiredSessionError,
    EXPIRED_SESSION_ERROR
} from "../../Error/Actions";
import { getCart } from "../../Cart/Actions";
import { toggleBlockingStatus, updateRequestCount } from "../../Status/Actions";
import { redirectToLoginPage, getUserInfo, receivedUserInfo } from "../../Account/Actions";
import {
    PAYMENT_OPTION_UPDATED,
    ADDRESSES_RECEIVED,
    COUNTRIES_RECEIVED,
    STATES_RECEIVED,
    SHIPPING_METHODS_RECEIVED,
    PAYMENT_METHODS_RECEIVED,
    BILLING_ADDRESS_ADDED,
    SHIPPING_ADDRESS_ADDED,
    BILLING_ADDRESS_SELECTED,
    SHIPPING_ADDRESS_SELECTED,
    SHIPPING_METHOD_SELECTED,
    CUSTOMER_PAYMENT_METHODS_RECEIVED,
    PAYMENT_METHOD_SELECTED,
    ORDER_SUMMARY_RECEIVED,
    ORDER_COMPLETE,
    PAYMENT_FAILED,
    APPROVAL_CODE_VALIDATED,
    APPROVAL_CODE_FAILED,
    APPROVAL_CODE_RESET,
    LEASE_COMPLETE,
    LEASE_FAILED
} from "../Constants";
// endregion

axios.defaults.headers.common["Is-Axios"] = true;
axios.defaults.headers["X-Requested-With"] = "Axios";

// region Export consts

// endregion

export function updatePaymentOption(paymentOption) {
    return {
        type: PAYMENT_OPTION_UPDATED,
        payload: paymentOption
    };
}

// region Addresses
export function getAddresses() {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Checkout/Addresses"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedAddresses(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedAddresses(data) {
    return {
        type: ADDRESSES_RECEIVED,
        payload: data
    };
}

export function getCountries(cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Metadata/Countries"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedCountries(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedCountries(data) {
    return {
        type: COUNTRIES_RECEIVED,
        payload: data
    };
}

export function getStates(countryId, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Metadata/States"), {
            params: { countryId }
        })
            .then(res => {
                const stateData = res.data.filter(x => x.stateName.indexOf("Armed Forces") === -1);
                dispatch(receivedServerError(false));
                dispatch(receivedStates(stateData));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb();
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedStates(data) {
    return {
        type: STATES_RECEIVED,
        payload: data
    };
}

export function addBillingAddress(address) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/BillingAddress"), Utilities.serializeJson(address), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(getUserInfo());
                dispatch(billingAddressAdded(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function billingAddressAdded(data) {
    return {
        type: BILLING_ADDRESS_ADDED,
        payload: data
    };
}

export function addShippingAddress(address) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/ShippingAddress"), Utilities.serializeJson(address), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(getUserInfo());
                dispatch(shippingAddressAdded(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function shippingAddressAdded(data) {
    return {
        type: SHIPPING_ADDRESS_ADDED,
        payload: data
    };
}

export function selectBillingAddress(address, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/SelectBillingAddress"), Utilities.serializeJson(address), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(billingAddressSelected(res.data));
                dispatch(getOrderSummary());
                dispatch(getUserInfo());
                dispatch(updateRequestCount(false));

                if (address.SameAsShipping) {
                    if (parseInt(address.Id) === 0) {
                        address.Id = res.data.existingAddresses[res.data.existingAddresses.length - 1].id;
                    }
                    dispatch(selectShippingAddress(address, cb))
                } else if (cb && typeof cb === "function") {
                    if (getState().requestCount === 0) {
                        dispatch(toggleBlockingStatus(false));
                    }

                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function billingAddressSelected(data) {
    return {
        type: BILLING_ADDRESS_SELECTED,
        payload: data
    };
}

export function selectShippingAddress(address, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/SelectShippingAddress"), Utilities.serializeJson(address), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(shippingAddressSelected(res.data));
                dispatch(getAddresses());
                dispatch(getOrderSummary());
                dispatch(getUserInfo());
                dispatch(receivedShippingMethods(res.data.shippingMethods));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function shippingAddressSelected(data) {
    return {
        type: SHIPPING_ADDRESS_SELECTED,
        payload: data
    };
}
// endregion

// region Shipping Method
function receivedShippingMethods(data) {
    return {
        type: SHIPPING_METHODS_RECEIVED,
        payload: data
    };
}

export function selectShippingMethod(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/SelectShippingMethod"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(shippingMethodSelected(res.data));
                dispatch(getOrderSummary());
                dispatch(receivedPaymentMethods(res.data.paymentMethods));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function shippingMethodSelected(data) {
    return {
        type: SHIPPING_METHOD_SELECTED,
        payload: data
    };
}
// endregion

// region Payment Method
export function getPaymentMethods() {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Checkout/PaymentMethods"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedPaymentMethods(res.data.paymentMethods));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedPaymentMethods(data) {
    return {
        type: PAYMENT_METHODS_RECEIVED,
        payload: data
    };
}

export function selectPaymentMethod(data, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/SelectPaymentMethod"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(paymentMethodSelected(data.Method));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function paymentMethodSelected(data) {
    return {
        type: PAYMENT_METHOD_SELECTED,
        payload: data
    };
}

export function setPaymentMethod(paymentMethod) {
    return {
        type: PAYMENT_METHOD_SELECTED,
        payload: paymentMethod
    };
}

export function getCustomerPaymentMethods(cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Checkout/CustomerPaymentMethods"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedCustomerPaymentMethods(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function receivedCustomerPaymentMethods(data) {
    return {
        type: CUSTOMER_PAYMENT_METHODS_RECEIVED,
        payload: data
    };
}
// endregion

// region Order Summary
export function getOrderSummary(cb, customCatch) {
    return function(dispatch, getState) {
        // dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.get(Utilities.buildUrl("/Checkout/OrderSummary"))
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedOrderSummary(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (!customCatch) {
                    if (error.response.status === 401 || error.response.status === 403) {
                        redirectToLoginPage();
                    } else {
                        dispatch(receivedServerError(true, error.response.data));
                        dispatch(receivedServerError(false));
                    }

                    if (getState().requestCount === 0) {
                        dispatch(toggleBlockingStatus(false));
                    }
                } else {
                    if (getState().requestCount === 0) {
                        dispatch(toggleBlockingStatus(false));
                    }

                    customCatch(error);
                }
            });
    };
}

function receivedOrderSummary(data) {
    return {
        type: ORDER_SUMMARY_RECEIVED,
        payload: data
    };
}
// endregion

// region Agreement
export function updateCustomerAgreement(data, cb) {
    return function(dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.put(Utilities.buildUrl("/Checkout/UpdateCustomerAgreement"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedUserInfo(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function updateProductAgreement(data, cb) {
    return function (dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.put(Utilities.buildUrl("/Checkout/UpdateProductAgreement"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedUserInfo(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function updateRentalAgreement(data, cb) {
    return function (dispatch, getState) {
        dispatch(updateRequestCount(true));

        return axios.put(Utilities.buildUrl("/Checkout/UpdateRentalAgreement"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(receivedUserInfo(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}
// endregion

// region Pay In Full
export function confirmPayment(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/ConfirmPayment"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(orderPaid(res.data));
                dispatch(getCart());
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                // dispatch(receivedServerError(true, error.response.data));
                // dispatch(receivedServerError(false));
                    dispatch(paymentFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function orderPaid(data) {
    return {
        type: ORDER_COMPLETE,
        payload: data
    };
}

export function paymentFailed(data) {
    return {
        type: PAYMENT_FAILED,
        payload: data
    };
}

export function resetOrderConfirmation() {
    return {
        type: ORDER_COMPLETE,
        payload: {}
    };
}
// endregion

// region Lease
export function applyForLease(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/ApplyForLease"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    dispatch(receivedServerError(true, error.response.data));
                    dispatch(receivedServerError(false));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

export function submitApprovalCode(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/ValidateApprovalCode"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(approvalCodeValidated(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    // dispatch(receivedServerError(true, error.response.data));
                    // dispatch(receivedServerError(false));
                    dispatch(approvalCodeFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function approvalCodeValidated(data) {
    return {
        type: APPROVAL_CODE_VALIDATED,
        payload: data
    };
}

export function approvalCodeFailed(data) {
    return {
        type: APPROVAL_CODE_FAILED,
        payload: data
    };
}

export function resetCurrentApprovalCode() {
    return {
        type: APPROVAL_CODE_RESET,
        payload: {}
    };
}

export function processLease(data, cb) {
    return function(dispatch, getState) {
        dispatch(toggleBlockingStatus(true));
        dispatch(updateRequestCount(true));

        return axios.post(Utilities.buildUrl("/Checkout/ProcessLease"), Utilities.serializeJson(data), {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
            .then(res => {
                dispatch(receivedServerError(false));
                dispatch(getCart());
                dispatch(leaseProcessed(res.data));
                dispatch(updateRequestCount(false));

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }

                if (cb && typeof cb === "function") {
                    cb(res.data);
                }
            })
            .catch(error => {
                dispatch(updateRequestCount(false));

                if (error.response.status === 401 || error.response.status === 403) {
                    redirectToLoginPage();
                } else {
                    // dispatch(receivedServerError(true, error.response.data));
                    // dispatch(receivedServerError(false));
                    dispatch(leaseFailed(error));
                }

                if (getState().requestCount === 0) {
                    dispatch(toggleBlockingStatus(false));
                }
            });
    };
}

function leaseProcessed(data) {
    return {
        type: LEASE_COMPLETE,
        payload: data
    };
}

export function leaseFailed(data) {
    return {
        type: LEASE_FAILED,
        payload: data
    };
}
// endregion